import ApiResultStatus from '../../../../shared/api/api-result/ApiResultStatus';
import AccessibleFeature from '../models/AccessibleFeature';
import getIfUserHasConversionsLogAccess from './getIfUserHasConversionsLogAccess';
import getIfUserHasFacebookAccountsAccess from './getIfUserHasFacebookAccountsAccess';
import getIfUserHasFilesAccess from './getIfUserHasFilesAccess';
import getIfUserHasTriggersAccess from './getIfUserHasTriggersAccess';

type AccessGetter = (userId: string) => Promise<
  | {
      errorMessage: string;
      status: ApiResultStatus.ERROR;
    }
  | {
      hasAccess: boolean;
      status: ApiResultStatus.OK;
    }
>;

const ACCESS_GETTERS: Record<AccessibleFeature, AccessGetter> = {
  [AccessibleFeature.CONVERSIONS_LOG]: getIfUserHasConversionsLogAccess,
  [AccessibleFeature.FACEBOOK_ACCOUNTS]: getIfUserHasFacebookAccountsAccess,
  [AccessibleFeature.FILES]: getIfUserHasFilesAccess,
  [AccessibleFeature.TRIGGERS]: getIfUserHasTriggersAccess,
};

export default async function getAccessibleFeatures(userId: string): Promise<
  | {
      accessibleFeatures: AccessibleFeature[];
      errorMessages: string[];
      status: ApiResultStatus.OK;
    }
  | {
      errorMessage: string;
      status: ApiResultStatus.ERROR;
    }
> {
  const accessibleFeatures: AccessibleFeature[] = [];

  const errorMessages: string[] = [];

  const availableAccessibleFeatures = Object.values(AccessibleFeature);

  await Promise.all(
    availableAccessibleFeatures.map(async (accessibleFeature) => {
      const result = await ACCESS_GETTERS[accessibleFeature](userId);

      if (result.status !== ApiResultStatus.OK) {
        errorMessages.push(result.errorMessage);
        return;
      }

      if (!result.hasAccess) {
        return;
      }

      accessibleFeatures.push(accessibleFeature);
    }),
  );

  if (errorMessages.length === availableAccessibleFeatures.length) {
    return {
      errorMessage: errorMessages.join('\n'),
      status: ApiResultStatus.ERROR,
    };
  }

  return {
    accessibleFeatures,
    errorMessages,
    status: ApiResultStatus.OK,
  };
}
